import DebugSettings from './debugSettings';
import AppConfig from './appConfig';

export default () => {
    if (AppConfig.isDevelopmentMode) {
        // If warnings are too much, it is possible to turn
        // it off, but the healthier approach is to fix the warnings.  =)
        console.warning = !DebugSettings.warning;
    }
};
